const ourSolutionsContainer = (theme) => ({
  padding: { xs: '4rem 2rem 6rem 2rem', m: '6rem 4rem 10rem 4rem' },
  borderRadius: '1.25rem',
  width: '100%',
  height: '100%',
  background: `linear-gradient(180deg, #000000 0%, ${theme.palette.contrast.A700} 100%)`,
});

const ourSolutionsContent = {
  gap: '1.5rem',
  width: '100%',
  maxWidth: '71.25rem',
};

const preheadingIconContainer = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const preheadingIcon = {
  objectFit: 'contain',
  width: '1.5rem',
};

const preheadingTypography = (theme) => ({
  fontWeight: 700,
  color: theme.palette.primary.A700,
});

const titleContainer = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: '0.5rem',
  alignSelf: 'stretch',
};

const titleTypography = {
  color: 'white',
  fontSize: { xs: '2rem', phone: '2.5rem' },
};

const subtitleTypography = (theme) => ({
  color: theme.palette.neutral.A300,
  fontWeight: 500,
});

const contentStack = {
  display: 'flex',
  flexDirection: { ipad: 'column', desktop: 'row' },
  alignItems: 'center',
  gap: '4rem',
  width: '100%',
  maxWidth: '71.25rem',
};

const imageContainer = (theme) => ({
  borderRadius: '0.75rem',
  border: `1px solid ${theme.palette.neutral.A700}`,
  maxHeight: '29rem',
  maxWidth: '32rem',
});

const imageStyles = {
  objectFit: 'fill',
  width: '100%',
  height: '100%',
  borderRadius: '0.75rem',
};

export {
  ourSolutionsContainer,
  ourSolutionsContent,
  preheadingIconContainer,
  preheadingIcon,
  preheadingTypography,
  titleContainer,
  titleTypography,
  subtitleTypography,
  contentStack,
  imageContainer,
  imageStyles,
};
